<template>
  <div>
    <a-card :bordered="false" title="报名须知">
      <a-form :form="form" style="padding-top: 30px;">

        <a-form-item label="当前报名" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-select v-decorator="['signupId']" size="large" placeholder="请选择报名" @change="onChangeSignupId">
            <a-select-option v-for="item of signupList" :value="item.signupNoticeId">{{item.title}}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="报名须知" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-textarea v-decorator="['content',
						{rules:
							[{
								 required: true, message: '报名须知不能为空!'
							}, 
              {max:20000,message:'不超过20000字！'}
            ]
					}]" placeholder="不超过20000字！" :rows="8"></a-textarea>
        </a-form-item>

        <a-form-item label="阅读等待时间" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-input style="width: 100px;" v-decorator="['waitTime', {rules: [{ required: true, message: '报名标题不能为空!' }]}]"/> 秒
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 12, offset: 5 }" style="padding-top: 30px;">
          <a-button size="large" type="primary" @click="handleSubmit">提 交</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script>
  import AdminCommon from './mixins/admin_common';

  export default {
    mixins: [AdminCommon],
    components: {},
    data() {
      return {
				// 当前报名
				currentNoticeInfo: {
					id: ''
				},
        signupList: [],
        form: this.$form.createForm(this)
      };
    },
    created() {
      this.ajaxGetSignupList();
    },
    methods: {
      async ajaxGetSignupList() {
        let { data } = await this.$ajax.gateway('/bm-kids/ISignupNoticeApi_querySignupNotices', { studentType: this.studentType });
        if (data.code === 200) {
          data = data.data;
          if (typeof data === 'object' && data.length > 0) {
            this.signupList = data;
            let signupId = this.signupList[0].signupNoticeId;
            this.form.setFieldsValue({ signupId });
            this.ajaxGetSignupProtocolById(signupId);
          }
        }
      },
      async ajaxGetSignupProtocolById(id) {
        // 根据报名通知查询报名须知内容 #李茹钰/2019-03-13#
        let { data } = await this.$ajax.gateway('/bm-kids/ISignupProtocolApi_getInfoBySignupNoticeId', {
          signupNoticeId: id
        });
        if (typeof data === 'object' && data.code === 200) {
          data = data.data;
          this.form.setFieldsValue({ content: data.content });
          this.form.setFieldsValue({ waitTime: data.waitTime });
					Object.assign(this.currentNoticeInfo, data);
        }
			},

			validateTextLength(rule, value, callback) {
				value = value.replace(/[\r\n]/g, '');

				let len = 0;
				for (let i = 0; i < value.length; i++) {
					let c = value.charCodeAt(i);
					// 单字节加1
					if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
						len++;
					} else {
						len += 2;
					}
				}

				if (len <= 80000) {
					callback();
				} else {
					callback('不能超过20000个中文字符！');
				}
			},

			handleSubmit() {
				this.form.validateFields(err => {
					if (err) return;
					this.submitSignupInfo();
				});
			},

      async submitSignupInfo() {
				let formVal = this.form.getFieldsValue();
				console.log('-> handleSubmit formVal', formVal);
				let params = {
					id: this.currentNoticeInfo.id,
					content: formVal.content,
					signupNoticeId: formVal.signupId,
					studentType: this.studentType,
					waitTime: formVal.waitTime
				};
				// 编辑或新增报名通知对应的报名须知 #李茹钰/2019-03-13#
				let { data } = await this.$ajax.gateway('/bm-kids/ISignupProtocolApi_addUpdateSignupProtocol', { body: params });
				if (data.code === 200 && data.data) {
					this.$message.success('保存成功');
				} else {
					this.$message.warning('保存失败');
				}
      },
      onChangeSignupId(value) {
        this.form.setFieldsValue({ signupId: value });
        this.ajaxGetSignupProtocolById(value);
      }
    }
  };
</script>

<style lang="stylus" scoped>
</style>
